import { T } from "../app/tokens.js";

export function CalculatedDateLabel({ event }) {
  if (!["calculated", "ambiguous"].includes(event?.provenance)) return null;
  const unverified = event.provenance === "ambiguous";
  return <span title={event.disclosure} tabIndex={0} data-testid={unverified ? "unverified-date-label" : "calculated-date-label"}
    style={{ color: T.mid, fontWeight: T.fwRegular, fontSize: T.fsXxs, whiteSpace: "nowrap", padding: "0 3px", border: `1px dotted ${T.mid}`, borderRadius: 3 }}>{unverified ? "unverified" : "calc"}</span>;
}
